// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qZBO","index":"styles_index__3xVdY"};